import { INTENT } from "../constants/intent.js";
const pickIntent = (intents) => {
  const result = {};
  const requiredIntents = new Set(intents);
  for (const [key, value] of Object.entries(INTENT)) {
    if (!requiredIntents.has(value)) {
      continue;
    }
    result[key] = value;
  }
  return result;
};
export {
  pickIntent
};
